import CopyBtn from "@/components/copy-btn";
import VaultFallbackMark from "@/components/pii-vault/vault-fallback-mark";
import EditCustomerDialog from "@/pages/(app)/returns/view/components/edit-customer/edit-customer-dialog";
import { ReturnRequestDto } from "@babackapp/private-api-client/types";
import useTranslation from "@babackapp/translations/use-translation";
import { Badge } from "@babackapp/ui/components/badge";
import { PersonIcon } from "@radix-ui/react-icons";

interface CustomerInfoProps {
  returnRequest: ReturnRequestDto;
}

export default function CustomerInfo({ returnRequest }: CustomerInfoProps) {
  const t = useTranslation();
  const { customer } = returnRequest;
  const name =
    `${customer.first_name ?? ""} ${customer.last_name ?? ""}`.trim();

  return (
    <div className="group">
      <div className={"flex flex-row items-center justify-between mb-2"}>
        <h2 className="text-sm font-medium text-gray-500 inline-flex items-center gap-2">
          <PersonIcon className="size-3" />
          {t("misc.customer")}
          <VaultFallbackMark isFromVault={returnRequest.vault?.identity} />
        </h2>
        <div className="opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <EditCustomerDialog
            returnRequest={returnRequest}
            key={returnRequest.id}
          />
        </div>
      </div>
      <div className={"flex flex-col gap-1 text-sm"}>
        <CopyBtn value={name}>
          <span>{name}</span>
        </CopyBtn>
        <CopyBtn value={customer.email ?? ""}>
          <span>{customer.email}</span>
        </CopyBtn>
        <CopyBtn value={customer.phone ?? ""}>
          <span>{customer.phone}</span>
        </CopyBtn>
        {customer.customerSegment?.name && (
          <div className="flex flex-col gap-1">
            <span className={"text-xs text-muted-foreground"}>Segment</span>
            <div className="flex items-center justify-between gap-1">
              <div>{customer.customerSegment?.name}</div>
            </div>
            <div className={"flex flex-1 flex-row gap-1"}>
              {!!customer.customerSegment?.hasFreeReturn && (
                <Badge variant={"secondary"}>
                  {t("returnDetail.rightBar.customerInfo.hasFreeReturn")}
                </Badge>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
